import * as THREE from 'three';

let gradient: THREE.DataTexture | null = null;

/** Rampa de 3 tonos para el sombreado cartoon. */
export function toonGradient(): THREE.DataTexture {
  if (gradient) return gradient;
  const data = new Uint8Array([90, 90, 90, 255, 180, 180, 180, 255, 255, 255, 255, 255]);
  gradient = new THREE.DataTexture(data, 3, 1, THREE.RGBAFormat);
  gradient.minFilter = THREE.NearestFilter;
  gradient.magFilter = THREE.NearestFilter;
  gradient.needsUpdate = true;
  return gradient;
}

const cache = new Map<string, THREE.Material>();

/** Material cartoon reutilizable (compartido entre mallas del mismo color). */
export function toon(color: number, opts: { emissive?: number; transparent?: boolean; opacity?: number; map?: THREE.Texture } = {}): THREE.MeshToonMaterial {
  const key = `${color}|${opts.emissive ?? 0}|${opts.opacity ?? 1}|${opts.map?.uuid ?? ''}`;
  let m = cache.get(key) as THREE.MeshToonMaterial | undefined;
  if (!m) {
    m = new THREE.MeshToonMaterial({
      color,
      gradientMap: toonGradient(),
      emissive: opts.emissive ?? 0x000000,
      transparent: opts.transparent ?? (opts.opacity ?? 1) < 1,
      opacity: opts.opacity ?? 1,
      map: opts.map,
    });
    cache.set(key, m);
  }
  return m;
}

/** Material propio (no compartido) para objetos que cambian de color. */
export function ownToon(color: number, emissive = 0): THREE.MeshToonMaterial {
  return new THREE.MeshToonMaterial({ color, gradientMap: toonGradient(), emissive });
}

/** Textura generada en un canvas. */
export function canvasTexture(w: number, h: number, draw: (ctx: CanvasRenderingContext2D) => void, repeat?: [number, number]): THREE.CanvasTexture {
  const c = document.createElement('canvas');
  c.width = w;
  c.height = h;
  draw(c.getContext('2d')!);
  const t = new THREE.CanvasTexture(c);
  t.colorSpace = THREE.SRGBColorSpace;
  if (repeat) {
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    t.repeat.set(repeat[0], repeat[1]);
  }
  t.anisotropy = 4;
  return t;
}

/** Libera geometrías, materiales no compartidos y texturas de un objeto. */
export function disposeObject(obj: THREE.Object3D) {
  obj.traverse((o) => {
    const mesh = o as THREE.Mesh;
    if (mesh.geometry) mesh.geometry.dispose();
    const mats = Array.isArray(mesh.material) ? mesh.material : mesh.material ? [mesh.material] : [];
    for (const m of mats) {
      if ([...cache.values()].includes(m)) continue;
      (m as THREE.MeshToonMaterial).map?.dispose();
      m.dispose();
    }
    if ((o as THREE.Sprite).isSprite) ((o as THREE.Sprite).material.map as THREE.Texture | null)?.dispose();
  });
}
